import { Card, Col, Image, message, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useGetOrganization } from "../../../../../api/v1";
import placeholder from "../../../../../assets/img/BUILDING_placeholder.svg";
import { getPresignedImage } from "../../../../../utils/media";
import { FinancialDimensions } from "./components/FinancialDimensions";

const { Text, Title } = Typography;

type SideDetailProps = {
  propertyDetails: any;
  fullUnitName: string;
  parentName: string;
  isUnit: boolean;
  refreshDetails?: () => void;
  showFinancialDimensions?: boolean;
};

export default (props: SideDetailProps) => {
  const {
    propertyDetails,
    fullUnitName,
    isUnit,
    parentName,
    refreshDetails,
    showFinancialDimensions = true,
  } = props;
  const { buildingName, address, image, propertyId, unitId, financialDimensions } = propertyDetails;

  const { organization } = useGetOrganization();
  const [imageData, setImageData] = useState("");
  const [galleryImages, setGalleryImages] = useState([]);
  const [profileImgId, setProfileImgId] = useState();

  const getImageUrl = async (data) => {
    getPresignedImage(data)
      .then((res) => {
        setImageData(res[0]);
      })
      .catch((e) => {
        setImageData("");
        message.error("Image not loaded");
      });
  };

  useEffect(() => {
    if (image && image.length) {
      const filtered = image.filter((e) => e.media_purposeT_type === "profile_photo");
      if (filtered.length > 0) {
        setProfileImgId(filtered[0].object_id);
        getImageUrl(filtered[0].data);
      }
      const galleryPhotos = image.filter((e) => e.media_purposeT_type === "property_photo");
      if (galleryPhotos.length) {
        setGalleryImages(galleryPhotos);
      }
    } else {
      setImageData("");
    }
  }, [image]);

  return (
    <Space direction="vertical" size={24} className="pd_tab_left">
      <Card bordered={false}>
        <Row gutter={[24, 24]} align="middle">
          <Col flex="1">
            <Space direction="vertical" size={16} className="w-100 text-center">
              <div className="prop_info">
                <Image
                  preview={false}
                  width={140}
                  height={80}
                  placeholder={true}
                  alt="Al Ghurair Residence"
                  src={placeholder}
                />
                <div className="sidebar_content">
                  <Title level={3} className="ag-primary mb-0">
                    {isUnit && fullUnitName ? fullUnitName : (buildingName ?? "")}
                  </Title>
                  <Space size={15}>
                    {isUnit ? (
                      <Text className="ag-primary RegularFont sentanceCase">{parentName}</Text>
                    ) : (
                      <>
                        <Text className="ag-primary RegularFont">
                          {address?.addressLine2 ?? address?.addressLine1} {address?.emirates}
                        </Text>
                      </>
                    )}
                  </Space>
                </div>
              </div>
            </Space>
          </Col>
          {organization?.enableFinancialDimensions && showFinancialDimensions && (
            <Col flex="14rem">
              <FinancialDimensions
                propertyId={propertyId}
                unitId={unitId}
                propertyFinancialDimensions={financialDimensions}
                onSubmitSuccess={refreshDetails}
              />
            </Col>
          )}
        </Row>
      </Card>
    </Space>
  );
};
